<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 15:09:30
-->
<template>
    <div class="table">
        <div class="operate_btn">
            <!-- 默认按钮 -->
            <a-button 
                class="operate_btn_default"
                type="primary"
                size="small"
                v-if="table && table.configs.operateBtn && table.configs.operateBtn.showSearch? table.configs.operateBtn.showSearch : false" 
                @click="handleSearch"
            >
                <component :is="$antIcons['SearchOutlined']"></component>{{ $t('base.search') }}
            </a-button>
            <a-button 
                class="operate_btn_default"
                type="primary" 
                size="small"
                v-if="table && table.configs.operateBtn && table.configs.operateBtn.showAdd? table.configs.operateBtn.showAdd : false" 
                @click="handleAdd"
            >
                <component :is="$antIcons['PlusOutlined']"></component>{{ $t('base.add') }}
            </a-button>

            <!-- 表头自定义按钮 -->
            <slot name="operateBtn"></slot>

            <!-- 右侧表格配置按钮 -->
            <div class="right_table_setting">
                <slot name="setting"></slot>
            </div>
        </div>
        <!-- 表格 -->
            <a-table 
                class="ant-table"
                :columns="table.columns" 
                :bordered="table.configs.bordered? 'bordered' : null"
                :data-source="table.data" 
                :scroll="table.configs.scroll? table.configs.scroll : null" 
                :row-class-name="table.configs.table.rowClassName && table.configs.table.rowClassName? table.configs.table.rowClassName : null"
                :row-selection="table.configs.rowSelection? rowSelectionObj : null"
                :pagination="table.configs.pagination? table.configs.pagination : false"
                :loading="table.configs.loading? table.configs.loading : false"
                :rowKey="(record)=>record.id"
                :expandedRowKeys="expandedRowKeys"
                @expand="expandRow"
                @resizeColumn="handleResizeColumn"
                @change="handleChange"
            >
                <!-- 自定义表头筛选 -->
                <template #customFilterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
                    <!-- search -->
                    <div style="padding: 8px" v-if="column.filterType == 'search'">
                        <a-input
                            ref="searchInput"
                            :value="selectedKeys[0]"
                            style="width: 188px; margin-bottom: 8px; display: block"
                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                            @pressEnter="handleTableSearch(selectedKeys, confirm, column.key)"
                        />
                        <a-button
                            type="primary"
                            size="small"
                            style="width: 90px; margin-right: 8px"
                            @click="handleTableSearch(selectedKeys, confirm, column.key)"
                        >
                            <template #icon><SearchOutlined /></template> {{ $t('base.search') }}
                        </a-button>
                        <a-button size="small" style="width: 90px" @click="handleTableReset(clearFilters, column.key)">
                            {{ $t('base.reset') }}
                        </a-button>
                    </div>
                    <!-- radio -->
                    <div style="padding: 8px" v-if="column.filterType == 'radio'">
                        <a-radio-group 
                            v-model:value="selectedKeys[0]" 
                            @change="e => setSelectedKeys(e.target.value !== null ? [e.target.value] : [])"
                        >
                            <a-radio 
                                style="display:block"
                                v-for="(item,index) in column.radioGroup" 
                                :key="index" 
                                :value="item.value"
                            >{{ item.text }}</a-radio>
                        </a-radio-group>
                        <a-divider style="margin:8px 0;"/>
                        <div style="display:block;text-align:right">
                            <a-button size="small" style="width: 70px; margin: 5px 8px 0 0" @click="handleTableReset(clearFilters, column.key)">
                                {{ $t('base.reset') }}
                            </a-button>
                            <a-button
                                type="primary"
                                size="small"
                                style="width: 70px; margin-top:5px"
                                @click="handleTableSearch(selectedKeys, confirm, column.key)"
                            >
                                {{ $t('base.confirm') }}
                            </a-button>
                        </div>
                    </div>
                </template>

                <!-- 自定义表头筛选图标 -->
                <template #customFilterIcon="{ filtered, column }">
                    <component v-if="column.antIcon && column.filterType" :is="$antIcons[column.antIcon]"></component>
                </template>

                <template #bodyCell="{ column, record }">
                    <!-- 表格列自定义内容 -->
                    <slot name="customCol" :props="{column,record}"></slot>
                    <slot name="tableAction" :props="{ column,record }"></slot>
                </template>

                <!-- 子表格 -->
                <template #expandedRowRender v-if="table.children">
                    <div v-for="(item,index) in table.children" :key="index">
                        <div>{{item.title}}</div>
                        <a-table
                            class="childrenTable"
                            :columns="item.innerColumns" 
                            :bordered="item.innerConfigs.bordered? 'bordered' : null"
                            :data-source="item.innerData" 
                            :scroll="item.innerConfigs.scroll? item.innerConfigs.scroll : null"
                            size="small"
                            :row-class-name="item.innerConfigs.table && item.innerConfigs.table.rowClassName? item.innerConfigs.table.rowClassName : null"
                            :row-selection="item.innerConfigs.rowSelection? rowSelectionObj : null"
                            :loading="item.innerConfigs.loading? item.innerConfigs.loading : false"
                            :pagination="item.innerConfigs.pagination"
                            @resizeColumn="handleResizeColumn"
                            @change="handleChange"
                        >
                            <template #bodyCell="{ column, record }">
                                <!-- 表格列自定义内容 -->
                                <slot name="childTableAction" :props="{ column,record }"></slot>
                            </template>
                        </a-table>
                    </div>
                </template>
            </a-table>
    </div>
</template>

<script setup>
    import { ref,watch } from "vue";

    const props = defineProps({
        table:{
            type:Object
        }
    })

    const expandedRowKeys = ref([])
    const emits = defineEmits(['handleSearch','handleAdd','handleChange','expandRow','handleTableSearch','handleTableReset'])

    const handleSearch = ()=>{
        emits('handleSearch')
    }
    const handleAdd = ()=>{
        emits('handleAdd')
    }

    const handleTableSearch = (selectedKeys, confirm, key) => {
        // console.log(key, selectedKeys ,'selectedKeys, confirm, dataIndex')
        // confirm();
        emits('handleTableSearch', selectedKeys, key)
    };

    const handleTableReset = (clearFilters,key) => {
        clearFilters({ confirm: true })
        emits('handleTableReset', key)
    };

    // 分页，排序，筛选
    const handleChange = (pagination, filters, sorter, { currentDataSource })=>{
        if(pagination){
            emits('handleChangePagination',pagination,{ currentDataSource })
        }else if(filters){
            emits('handleChangeFilters',filters,{ currentDataSource })
        }else if(sorter){
            emits('handleChangeSorter',sorter,{ currentDataSource })
        }
        
    }

    const expandRow = (expanded, record)=>{
        if (expandedRowKeys.value.length > 0) {
            let index = expandedRowKeys.value.indexOf(record.id);
            if (index > -1) {
                expandedRowKeys.value.splice(index, 1);
            } else {
                //如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
                expandedRowKeys.value.splice(0, expandedRowKeys.value.length);
                expandedRowKeys.value.push(record.id);
            }
        } else {
            expandedRowKeys.value.push(record.id);  
        }

        emits('expandRow',expanded,record)
    }

    // 复选框
    const rowSelectionObj = {
      onChange: (selectedRowKeys, selectedRows) => {
        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      getCheckboxProps: (record) => ({
        disabled: record.name === 'Disabled User',
        name: record.name,
      }),
    };

    // 伸缩列
    function handleResizeColumn(w, col){
        col.width = w;
    }

    defineExpose({
        expandedRowKeys
    })
</script>

<style lang="scss" scoped>
.table{
    .ant-table {
        ::v-deep .ant-table-cell{
            text-align: center;
        }
        
        :deep(.table-striped) td {
            background-color: #fafafa;
        }

        ::v-deep .ant-table-body{
            max-height: 578px;
        }
    }

    .operate_btn{
        .operate_btn_default{
            margin: 0 10px 10px 0;
        }
    }

    .right_table_setting{
        float: right;

        ::v-deep .anticon {
            font-size: 20px;
            margin: 0 10px;
        }
    }
    
}

// 子表格的表头样式
::v-deep .childrenTable{
    .ant-table-thead > tr > th{
        padding: 10px;
        font-size: 13px;
        font-weight: bold;
        background: #b6cafd;
        text-align: center;
    }
}

::v-deep .ant-table-row-expand-icon:focus, 
::v-deep .ant-table-row-expand-icon:hover{
    outline: none;
}

::v-deep .ant-table-pagination.ant-pagination{
    margin: 5px 0;
}

</style>